import { combineReducers } from 'redux';
import authenticationReducer from '../Login/authenticationReducer';
// Combine reducers with routeReducer which keeps track of
// router state
import { routeReducer } from 'redux-simple-router';
import { reducer as formReducer } from 'redux-form';
import alertMsgReducer from '../MsgNotify/msgNotifyReducer';
import navbarReducer from './Navbar/reducer';
import apvReducer from '../APV/reducer';
import projectFormReducer from '../Project/CreateProject/reducer';
import activityOverviewReducer from '../Project/ActivityOverview/reducer';
import registerActivitiesReducer from '../Project/RegisterActivities/reducer';
import chatReducer from '../Project/RegisterActivities/Chat/reducer';
import weeklyOverviewReducer from '../Project/WeekOverview/reducer';
import projectDashboardReducer from '../Project/Dashboard/reducer';
import createSalaryReducer from '../Project/Salary/CreateSalary/reducer';
import salaryReducer from '../Project/Salary/reducer';
import spinnerReducer from '../Common/SmartSpinner/reducer';

import bookEmployeeReducer from '../ShortTermProjects/EmployeeWeekOverview/reducer';
import kanbanReducer from '../ShortTermProjects/Kanban/reducer';
import dailyReportReducer from '../ShortTermProjects/Workplace/DailyReport/reducer';
import dailyReportUsageReducer from '../ShortTermProjects/Workplace/DailyReport/Usage/reducer';
import dailyReportActivitiesReducer from '../ShortTermProjects/Workplace/DailyReport/Activities/reducer';
import dailyReportEmployeesReducer from '../ShortTermProjects/Workplace/DailyReport/Employees/reducer';
import dailyReportDescriptionReducer from '../ShortTermProjects/Workplace/DailyReport/Description/reducer';
import dailyReportRemarkReducer from '../ShortTermProjects/Workplace/DailyReport/Remark/reducer';

import dailyReportDeliveryNotesReducer from '../ShortTermProjects/Workplace/DailyReport/DeliveryNotes/reducer';
import dailyReportControlAreaReducer from '../ShortTermProjects/Workplace/DailyReport/ControlArea/reducer';
import dailyReportMeasurementsReducer from '../ShortTermProjects/Workplace/DailyReport/Measurements/reducer';
import dailyReportSignatureReducer from '../ShortTermProjects/Workplace/DailyReport/Signature/reducer';

import workplaceOverviewReducer from '../ShortTermProjects/Workplace/Overview/reducer';
import workplaceOverviewDescriptionReducer from '../ShortTermProjects/Workplace/Overview/description/reducer';
import workplaceImagesReducer from '../ShortTermProjects/Workplace/Images/reducer';
import workplaceTasksReducer from '../ShortTermProjects/Workplace/Overview/Tasks/reducer';
import workplaceFeedsReducer from '../ShortTermProjects/Workplace/Overview/Feed/reducer';
import employeeListViewReducer from '../ShortTermProjects/Kanban/EmployeeListView/reducer';
import PCalcReducer from '../ShortTermProjects/Workplace/PCalc/reducer';
import InvoiceReducer from '../ShortTermProjects/Workplace/Invoice/reducer';
import TilbudReducer from '../ShortTermProjects/Workplace/Tilbud/reducer';

import productReducer from '../Product/reducer';
import customPricelistReducer from '../CustomPricelist/reducer';
import departmentReducer from '../Department/reducer';
import headingSubtextReducer from '../HeadingSubtext/reducer';
import pricelistsListReducer from '../PricelistsList/reducer';
import { keaReducer } from 'kea'


const rootReducer = combineReducers({
  kea: keaReducer('kea'),
  authenticationReducer,
  navbarReducer,
  routing: routeReducer,
  alertMsgReducer,
  projectFormReducer,
  activityOverviewReducer,
  form: formReducer,
  registerActivitiesReducer,
  weeklyOverviewReducer,
  projectDashboardReducer,
  chatReducer,
  spinnerReducer,
  createSalaryReducer,
  salaryReducer,
  bookEmployeeReducer,
  kanbanReducer,
  dailyReportReducer,
  dailyReportUsageReducer,
  dailyReportActivitiesReducer,
  dailyReportEmployeesReducer,
  dailyReportDeliveryNotesReducer,
  dailyReportDescriptionReducer,
  dailyReportMeasurementsReducer,
  dailyReportRemarkReducer,
  dailyReportSignatureReducer,
  departmentReducer,
  workplaceOverviewReducer,
  workplaceOverviewDescriptionReducer,
  workplaceImagesReducer,
  employeeListViewReducer,
  productReducer,
  customPricelistReducer,
  workplaceTasksReducer,
  workplaceFeedsReducer,
  PCalcReducer,
  headingSubtextReducer,
  pricelistsListReducer,
  InvoiceReducer,
  TilbudReducer,
  apvReducer,
  dailyReportControlAreaReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/App/MainClient/rootReducer.js